export const monthNames = [
  'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
];

export const SETTLEMENT_SELECTABLE_YEAR_START = 2023;

export function getSettlementSelectableYears(now = new Date()): number[] {
  const yearEnd = Math.max(SETTLEMENT_SELECTABLE_YEAR_START, now.getFullYear());
  const count = yearEnd - SETTLEMENT_SELECTABLE_YEAR_START + 1;
  return Array.from({ length: count }, (_, i) => SETTLEMENT_SELECTABLE_YEAR_START + i);
}

export function getDefaultSettlementPeriod(reference = new Date()): { month: string; year: number } {
  const monthStart = new Date(reference.getFullYear(), reference.getMonth(), 1);
  const previousMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() - 1, 1);

  if (previousMonth.getFullYear() < SETTLEMENT_SELECTABLE_YEAR_START) {
    return {
      month: monthNames[0],
      year: SETTLEMENT_SELECTABLE_YEAR_START,
    };
  }

  return {
    month: monthNames[previousMonth.getMonth()],
    year: previousMonth.getFullYear(),
  };
}
